import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, Card, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { COLORES } from '../../../../config/colores'
import { cerealesColor } from '../../../../config/cereales'
import InfoIcon from '@material-ui/icons/Info'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  contenidoCenter: {
    display: 'flex',
    alignItems: 'center'
  }
}))

function GraficoCallesButo (props) {
  const { camListosParaBruto, callesDeBruto, saveCamiones } = props
  const [camiones, setCamiones] = useState([])
  const classes = useStyles()

  const saveCamionesRef = useRef(saveCamiones)

  useEffect(() => {
    saveCamionesRef.current = saveCamiones
  }, [saveCamiones])

  useEffect(() => {
    const calles = []
    if (callesDeBruto) {
      callesDeBruto.forEach(calle => {
        const nombreCalle = calle.nombreCorto.trim()
        calles[nombreCalle] = { id: nombreCalle, camiones: [] }
      })
    } else {
      ['CALLE1', 'CALLE2', 'CALLE3'].forEach(id => {
        calles[id] = { id, camiones: [] }
      })
    }

    let agrupado = calles
    if (camListosParaBruto && camListosParaBruto.length > 0) {
      agrupado = camListosParaBruto.reduce((a, d) => {
        const calleId = d.calleDeBruto ? d.calleDeBruto.trim() : 'CALLE1'

        if (!a[calleId]) {
          a[calleId] = {
            id: calleId,
            camiones: []
          }
        }

        a[calleId].camiones.push({
          camion: d.camion.trim(),
          cereal: d.cereal,
          claveCereal: d.claveCereal.trim(),
          autodescargable: d.autodescargable,
          calificacion: d.calificacionCereal || null,
          caravana: d.caravana
        })

        return a
      }, { ...calles })

      setCamiones(Object.values(agrupado))
      saveCamionesRef.current(agrupado)
    }
  }, [camListosParaBruto, callesDeBruto])

  const ICONSILOAPARTE = <InfoIcon style={{ color: '#000000' }} />

  return (
    <Card className='p-4 shadow-sm'>
      <h5 className='mb-4 text-center'>Estado de calles de bruto</h5>
      <div className={classes.contenidoCenter}> {ICONSILOAPARTE} <small>Descarga silo aparte</small></div>
      <div className={classes.contenidoCenter} style={{ margin: '8px 0' }}>
        <div
          style={{
            width: '25px',
            height: '18px',
            borderRadius: '4px',
            border: '3px solid rgba(0,0,0,0.8)',
            marginRight: '8px'
          }}
        />
        <small>Autodescargable</small>
      </div>
      <Row className='align-items-end'>
        {camiones.map((calle, index) => (
          <Col key={index} className='text-center'>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column-reverse',
                alignItems: 'center',
                gap: '4px',
                borderBottom: '2px solid #333',
                paddingBottom: '5px'
              }}
            >
              {calle.camiones.map((camion, id) => (
                <OverlayTrigger
                  key={id}
                  placement='top'
                  overlay={
                    <Tooltip
                      style={{ zIndex: 9999 }}
                      id={`tool-${calle.id}-${id}`}
                    >
                      <strong>Patente:</strong> {camion.camion} <br />
                      <strong>Cereal:</strong> {camion.cereal} <br />
                      {camion.calificacion && camion.calificacion} <br />
                      {camion.autodescargable && 'Autodescargable'}
                      {!camion.caravana && 'Silo aparte'}
                    </Tooltip>
                  }
                >
                  <div
                    style={{
                      width: '80%',
                      height: '25px',
                      backgroundColor: cerealesColor[camion.claveCereal] || COLORES.grey.dark,
                      borderRadius: '4px',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      border: camion.autodescargable ? '3px solid rgba(0,0,0,0.4)' : '1px solid rgba(0,0,0,0.4)'
                    }}
                    className='camion-bloque'
                  >
                    {!camion.caravana && ICONSILOAPARTE }
                  </div>
                </OverlayTrigger>
              ))}
            </div>
            <div className='mt-2 font-weight-bold'>{calle.id}</div>
            <small className='text-muted'>{calle.camiones.length} {calle.camiones.length === 1 ? 'camion' : 'camiones' }</small>
          </Col>
        ))}
      </Row>
    </Card>
  )
}

export default GraficoCallesButo
